import {
  DataExportationToolbox,
  HeatmapToolbox,
  JourneymapToolbox,
  AggregateJourneymapToolbox,
  CircumplexToolbox,
  VideoToolBox
} from './visualisationTypes';

class VisualisationsHelper {
  static analysisOptions = {
    // journeyMap: JourneymapToolbox,
    // aggregateJourneyMap: AggregateJourneymapToolbox,
    dataExportation: DataExportationToolbox,
    // heatMap: HeatmapToolbox,
    // circumplex: CircumplexToolbox,
    // video: VideoToolBox
  };

  static analysisTypeExists(type) {
    if (!Object.prototype.hasOwnProperty.call(this.analysisOptions, type)) {
      throw new TypeError(`Analysis of type ${type} is not supported.`);
    }
  }

  static addParams(type, ...args) {
    this.analysisTypeExists(type);

    return this.analysisOptions[type].addParams(...args);
  }

  static canProcess(type, ...args) {
    this.analysisTypeExists(type);

    return this.analysisOptions[type].canProcess(...args);
  }

  static getVisualisationComponent(type, ...args) {
    this.analysisTypeExists(type);

    return this.analysisOptions[type].getVisualisationComponent(...args);
  }

  static getProcessButtonLabel(type, ...args) {
    this.analysisTypeExists(type);

    return this.analysisOptions[type].getProcessButtonLabel(...args);
  }

  static getBlockParameters(type, ...args) {
    this.analysisTypeExists(type);

    return this.analysisOptions[type].getBlockParameters(...args);
  }
}

export default VisualisationsHelper;



// WEBPACK FOOTER //
// ./src/scenes/analysis/lib/VisualisationsHelper.js